<div [ngClass]="{background : collapseField}">
  <div class="d-flex flex-row flex-wrap justify-content-start">
    @for (item of contents; track trackContent(i, item); let i = $index) {
      <div class="d-flex flex-row align-items-center" [style.flex]="calcItemWidth(i)"
        >
        <div class="flex-fill mt-2" [style.marginRight.px]="calcItemMargin(i)">
          <ng-template [ngTemplateOutlet]="item.innerTemplate"></ng-template>
        </div>
      </div>
    }
  </div>
</div>